import styled from 'styled-components';

import { Waiter } from '../Waiter';

export const $Waiter = styled(Waiter)`
	width: 100%;
	height: 100%;
`;
